import React from 'react';
import { Button } from '../ui/button';
import { X, Sparkles } from 'lucide-react';

const ChatHeader = ({ selectedDoc, onClose }) => (
  <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-gradient-to-r from-[#2B8FD8]/5 to-white">
    <div className="flex items-center gap-2">
      <div className="w-8 h-8 rounded-lg bg-[#2B8FD8] flex items-center justify-center">
        <Sparkles className="h-4 w-4 text-white" />
      </div>
      <div>
        <h3 className="text-sm font-semibold text-slate-900">AI Assistant</h3>
        <p className="text-[10px] text-slate-500">
          {selectedDoc ? `Context: ${selectedDoc.title}` : 'Project scope'}
        </p>
      </div>
    </div>
    <Button variant="ghost" size="sm" onClick={onClose} className="h-8 w-8 p-0">
      <X className="h-4 w-4" />
    </Button>
  </div>
);

export default ChatHeader;
